export default __webpack_public_path__ + "static/media/general_practitioner.220da5a9.png";